import { createFileRoute } from "@tanstack/react-router";
import { zodValidator, fallback } from "@tanstack/zod-adapter";
import { z } from "zod";
import { AnunciosPanel } from "@/components/admin/AnunciosPanel";

export const PAGE_SIZES = [50, 100, 200] as const;

const searchSchema = z.object({
  page: fallback(z.number().int().min(1), 1).default(1),
  pageSize: fallback(z.union([z.literal(50), z.literal(100), z.literal(200)]), 100).default(100),
  open: z.string().uuid().optional(),
});

export const Route = createFileRoute("/admin/anuncios")({
  validateSearch: zodValidator(searchSchema),
  component: AnunciosPanel,
});
